@if (true) {
<div class="flex flex-column-reverse-m flex-column-reverse-s"
     [ngClass]="[component.background_color || 'bg-col-5', component.text_color || 'col-1']">
    <div class="w-5 w-12-m w-12-s p-l-10 p-l-9-l p-l-3-m p-l-4-s m-t-4-m m-t-6-s flex flex-middle">
        <div class="w-10-x w-10-l p-l-12-x p-r-3 p-r-4-m p-r-6-s">
            <h2 class="m-b-2 m-b-3-s"
                sizeClass="SM: h2, XL: h1"
                *iCms="'title' of component; content: 'html'">
            </h2>
            <read-more class="p1"
                       [text]="component.copy"
                       [limit]="170"
                       [readLess]="true"
                       [buttonStyle]="component.button_white ? 'button-inline-white' : 'button-inline'">
            </read-more>
        </div>
    </div>
    <div class="pos-relative w-7 w-12-m w-12-s">
        <href class="w-12 ratio-7-3 ratio-3-2-m ratio-3-2-s overflow-hidden"
           [link]="component.link">
            <shell></shell>
            @if (component.image) {
            <img [image]="component.image"
                 class="rf">
            }
        </href>
        <shop-this-look [content]="component"
                        [bigSpace]="true"></shop-this-look>
    </div>

</div>
}
